import styled, { css } from 'styled-components';

import { Button, ChatTextareaField } from '@speeki/global-ui-components';

import { breakpoints } from '@shared/constants';

export const ChatFormWrapperActions = styled.div`
    ${({ theme: { palette } }) => css`
        align-items: flex-start;
        border-top: 1px solid ${palette.neutral.dividers};
        display: flex;
        flex-wrap: wrap;
        padding-top: 24px;

        @media (max-width: ${breakpoints.md}px) {
            border-bottom: 1px solid ${palette.neutral.dividers};
            border-top: none;
            margin: 0 -16px 16px;
            padding: 0 16px 8px;
            width: calc(100% + 32px);
        }
    `}
`;

export const InnerWrapper = styled.div`
    width: 100%;

    @media (max-width: ${breakpoints.md}px) {
        margin: 0 auto;
        max-width: 718px;
    }
`;

export const FormElementsWrapper = styled.div`
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
`;

export const InputsWrapper = styled.div`
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    width: calc(100% - 55px);
`;

export const BubblesWrapper = styled.div`
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    margin-left: -4px;
    margin-right: -4px;
    width: 100%;

    & + ${InputsWrapper} {
        margin-top: 8px;
    }

    @media (max-width: ${breakpoints.md}px) {
        margin: 0;
    }
`;

export const TextareaWrapper = styled.div`
    align-items: flex-end;
    display: grid;
    grid-template-columns: 1fr auto;
    position: relative;
    width: 100%;
`;

export const SendButtonWrapper = styled.div<{ isError?: boolean }>(
    ({ isError }) => css`
        margin-bottom: ${isError ? 28 : 8}px;
        margin-left: 16px;
    `,
);

export const MessageTextarea = styled(ChatTextareaField)`
    margin-bottom: 8px;
`;

export const MessageInput = styled.input(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.neutral.gray};
        border-radius: ${radius[30]}px;
        border: none;
        caret-color: ${palette.primary.default};
        line-height: 24px;
        margin-bottom: 8px;
        outline: none;
        padding: 8px 24px;
        resize: none;
        width: 100%;

        ::placeholder {
            color: ${palette.text.assistive};
        }
    `,
);

export const BubbleInput = styled(Button)`
    margin-bottom: 8px;
    margin-left: 4px;
    margin-right: 4px;

    @media (max-width: ${breakpoints.md}px) {
        width: 100%;
    }
`;

export const SelectWrapper = styled.div`
    padding-bottom: 8px;
    width: 100%;
`;

export const DateFieldWrapper = styled.div`
    margin-bottom: 8px;
    width: 100%;
`;

// skeletons
const SkeletonContainer = styled.div`
    align-items: flex-end;
    display: flex;
    flex: 1;
    justify-content: space-between;
`;

const SkeletonWrapper = styled.div`
    width: calc(100% - 55px);
`;

const SkeletonSubmit = styled.div`
    width: 38px;
`;

export const ReportConversationFormSkeleton = {
    Container: SkeletonContainer,
    Submit: SkeletonSubmit,
    Wrapper: SkeletonWrapper,
};
